import React, { useContext, useState } from 'react';
import SignUp from '../components/SignUp';
import SignIn from '../components/SignIn';
import { Container } from 'semantic-ui-react';
import styled, { createGlobalStyle } from 'styled-components';
import Footer from '../../genericComponents/Footer';
import Header from '../components/Header';
import Helmet from 'react-helmet';
import { Redirect, useLocation } from 'react-router-dom';
import { routes } from '../../../helpers/routes';
import { Context } from '../../../context/globalContext';
import { GET_CUSTOM_TOKEN_BY_UID } from '../../../helpers/graphqlQueries'
import firebase from "firebase/app";
import "firebase/auth";


export default function AuthScreen({isAuth}) {
  
  let location = useLocation();
  // const [activeIndex, setActiveIndex] = useState(location.pathname === routes.SIGNUP ? 0 : 1)
  const { graphQLClient, state: { user } } = useContext(Context);

  // if(isAuth)return(<Redirect to={`/home/${user.username}`} />)
  if(isAuth){
    graphQLClient
      .query({
        variables: { uid: firebase.auth().currentUser.uid },
        query: GET_CUSTOM_TOKEN_BY_UID,
      })
        .then((result) => {
          const token = result?.data?.getAuthTokenByUid?.token;
          window.location.replace(`${process.env.REACT_APP_FLUTTER_APP_URL}?authToken=${token}`);
        })
        .catch((err) => console.log(err));
    return <></>
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Auth</title>
      </Helmet>
      <GlobalStyle />
      <Header />
      <ContainerWrapper>
        {location.pathname === routes.SIGNUP ? <SignUp /> : <SignIn />}
      </ContainerWrapper>
      <Footer />
    </>
  )
}

const GlobalStyle = createGlobalStyle`
  body {
    background-color:#f9f9f9;
  }
  input{
    background-color: #f9f9f9 !important;
    padding: 1em !important;
    font-size: 1.2em !important;
  }
  .row,.ui.grid{
    margin: 0 !important;
  }
  .ui.secondary.pointing.menu .item{
    border-color: #eeaa35 !important;
    font-size: 1.5em;
  }
  .ui.secondary.pointing.menu .active.item{
    border-bottom-width: 4px !important;
  }
`;
const ContainerWrapper = styled(Container)`
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1),
    0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 20px 0px;
`;
